import React, {useContext, useMemo} from 'react';
import {FormContext} from "./MDForm";
import {DeclaredComponent} from "../DynamicComponent";


export function Match({attr, path, cases, 'default': byDefault}) {
  const formContext = useContext(FormContext);
  const val = attr ? formContext.getValueByAttr(attr) : formContext.getValue(path);

  for (let {pattern, component} of cases) {

    const regExp = useMemo(() => new RegExp('pattern'), [pattern]);

    if (regExp.test(val ? '' : val + '')) {
      return <DeclaredComponent declaration={component} />
    }
  }

  if (byDefault) {
    return <DeclaredComponent declaration={byDefault} />
  }

  return null;
}
